import { render, staticRenderFns } from "./SimpleReports.vue?vue&type=template&id=095ffd09&scoped=true"
import script from "./SimpleReports.vue?vue&type=script&lang=ts"
export * from "./SimpleReports.vue?vue&type=script&lang=ts"
import style0 from "./SimpleReports.vue?vue&type=style&index=0&id=095ffd09&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095ffd09",
  null
  
)

export default component.exports